module.exports = __webpack_public_path__ + "media/src/assets/Images/Redpagos-cfe92bf67eb1d742851c8bbd303450d1.svg";